var AddEditUserActionsModalController = /** @class */ (function () {
    function AddEditUserActionsModalController() {
        // this.userId = this.resolve.userId;
        // this.buId = this.resolve.buId;
        // this.isCorporate = this.resolve.isCorporate;
    }
    AddEditUserActionsModalController.prototype.$onInit = function () {
        this.userId = this.resolve.userId;
        this.buId = this.resolve.buId;
        this.isCorporate = this.resolve.isCorporate;
        if (this.isCorporate) {
            this.clientOrBuLabel = "BU";
        }
        else {
            this.clientOrBuLabel = "Client";
        }
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    AddEditUserActionsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    AddEditUserActionsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return AddEditUserActionsModalController;
}());
// import * as TEMPLATE from './add-edit-user-actions-modal.html';
import * as TEMPLATE from 'raw-loader!./add-edit-user-actions-modal.html';
export var AddEditUserActionsModalComponent = {
    selector: 'addEditUserActionsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: AddEditUserActionsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addEditUser/addEditUserActionsModal/add-edit-user-actions-modal.html'
    }
};
//# sourceMappingURL=add-edit-user-actions.component.js.map